import { Typography, Box } from "@mui/material";
import { ReactNode } from "react";
import { SectionCard } from "./SectionCard";

/**
 * DashboardCard
 *
 * A compact, styled container for dashboard charts and metrics.
 * Uses SectionCard in compact mode to match the landing page aesthetic.
 * All cards share a consistent content height so side-by-side cards align.
 *
 * @param {string} title - The main heading for the card.
 * @param {string} [description] - A short explanation displayed below the title.
 * @param {string} [helperText] - Optional helper text shown beneath the content.
 * @param {ReactNode} children - The chart or content to render.
 */
export const DashboardCard = ({
  title,
  description,
  helperText,
  children,
}: {
  title?: string;
  description?: string;
  helperText?: string;
  children: ReactNode | ((isFullscreen: boolean) => ReactNode);
}) => {
  const content = typeof children === "function" ? children(false) : children;
  return (
    <SectionCard title={title} subtitle={description} compact>
      <Box sx={{ height: 320, overflow: "visible", mb: helperText ? 1 : 0 }}>{content}</Box>

      {helperText && (
        <Typography variant="caption" color="text.secondary" sx={{ pt: 0.5 }}>
          {helperText}
        </Typography>
      )}
    </SectionCard>
  );
};
